export class DataClassesDetails {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "dataClasses",
            "baseName": "dataClasses",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "eonDataClassifications",
            "baseName": "eonDataClassifications",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "isOverridden",
            "baseName": "isOverridden",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DataClassesDetails.attributeTypeMap;
    }
    constructor() {
    }
}
